'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Dictionary } from '@/src/lib/dictionary/types';
import { SelectOption } from '@/src/types/select-option';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { PRICING_REFERENCE_NONE } from '@/src/app/components/Header/AccountCards/lib/account-card-helpers';
import { eventBus } from '@/src/lib/core/event/bus';
import { EventBusName } from '@/src/lib/core/event/types';
import FormikSelect from '@/src/app/components/Select/FormikSelect';
import Button from '@/src/app/components/Button/Button';
import { getSelectedPricingReferenceOptionValue } from '@/src/lib/company-user/utils/company-user-utils';
import { DeserializedCart } from '@/src/lib/cart/glue/types/deserialized';
import { useAsyncStartTransition } from '@/src/lib/utils/hooks/use-async-start-transition';
import { setSelectedPricingReferenceAndAccount } from '@/src/lib/cart/business/set-selected-pricing-reference.actions';
import { isFailure } from '@/src/lib/http/business/server-action-results';
import { useFormHelpers } from '@/src/lib/utils/form-helpers';
function AccountChangeForm(t0) {
  const $ = _c(28);
  const {
    isCurrentAccount,
    dict,
    pricingReferenceOptions,
    companyUserId,
    cart,
    lang
  } = t0;
  const {
    handleErrors
  } = useFormHelpers(dict);
  let t1;
  if ($[0] !== cart || $[1] !== isCurrentAccount) {
    t1 = isCurrentAccount ? getSelectedPricingReferenceOptionValue(cart) : undefined;
    $[0] = cart;
    $[1] = isCurrentAccount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedPricingReference = t1;
  const asyncStartTransition = useAsyncStartTransition();
  const t2 = selectedPricingReference || PRICING_REFERENCE_NONE;
  let t3;
  if ($[3] !== companyUserId || $[4] !== t2) {
    t3 = {
      companyUserId,
      pricingReference: t2
    };
    $[3] = companyUserId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== asyncStartTransition || $[7] !== handleErrors || $[8] !== isCurrentAccount || $[9] !== lang) {
    t4 = async values => {
      ;
      try {
        await asyncStartTransition(async () => {
          const response = await setSelectedPricingReferenceAndAccount(lang, values);
          if (isFailure(response)) {
            throw response.error;
          }
        });
        if (!isCurrentAccount) {
          eventBus.emit(EventBusName.ACCOUNT_CHANGED, {
            companyUserId: values.companyUserId,
            pricingReference: values.pricingReference
          });
        }
        eventBus.emit(EventBusName.HEADER_NAVIGATION_CLICK_CLOSE_ACCOUNT_MODAL);
        eventBus.emit(EventBusName.ACCOUNT_OR_PRICING_REFERENCE_CHANGED, {
          companyUserId: values.companyUserId,
          pricingReference: values.pricingReference
        });
      } catch (t5) {
        const error = t5;
        handleErrors(error, true);
      }
    };
    $[6] = asyncStartTransition;
    $[7] = handleErrors;
    $[8] = isCurrentAccount;
    $[9] = lang;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      initialValues: t3,
      onSubmit: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const formik = useFormik(t5);
  const isSubmitDisabled = isCurrentAccount && !formik.dirty || formik.isSubmitting;
  const t6 = formik.handleSubmit;
  const t7 = dict.general.selectFieldPlaceholder;
  const t8 = dict.userProfile.changeAccountModal.selectFieldLabel;
  const t9 = formik.isSubmitting;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = Yup.object({});
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== dict.general.selectFieldPlaceholder || $[16] !== dict.userProfile.changeAccountModal.selectFieldLabel || $[17] !== formik || $[18] !== pricingReferenceOptions) {
    t11 = <FormikSelect formik={formik} options={pricingReferenceOptions} placeholder={t7} label={t8} name="pricingReference" className="w-1/2" disabled={t9} formikValidationSchema={t10} />;
    $[15] = dict.general.selectFieldPlaceholder;
    $[16] = dict.userProfile.changeAccountModal.selectFieldLabel;
    $[17] = formik;
    $[18] = pricingReferenceOptions;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== dict.userProfile.changeAccountModal.selectButtonLabel || $[21] !== formik.isSubmitting || $[22] !== isSubmitDisabled) {
    t12 = <div className="flex flex-col justify-end"><Button className="h-[50px]" disabled={isSubmitDisabled} priority={true} primary={true} type="submit" loading={formik.isSubmitting}>{dict.userProfile.changeAccountModal.selectButtonLabel}</Button></div>;
    $[20] = dict.userProfile.changeAccountModal.selectButtonLabel;
    $[21] = formik.isSubmitting;
    $[22] = isSubmitDisabled;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== formik.handleSubmit || $[25] !== t11 || $[26] !== t12) {
    t13 = <form onSubmit={t6} className="flex justify-between">{t11}{t12}</form>;
    $[24] = formik.handleSubmit;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
export default AccountChangeForm;